(function(){
  'use strict';
  const toggle=document.querySelector('[data-menu-toggle]');
  const mobile=document.getElementById('mobile-menu');
  if(toggle&&mobile){
    toggle.addEventListener('click',()=>{
      const show=mobile.hidden;
      mobile.hidden=!show;
      toggle.setAttribute('aria-expanded',String(show));
      document.body.classList.toggle('menu-open',show);
    });
    document.addEventListener('keydown',event=>{if(event.key==='Escape'&&!mobile.hidden){mobile.hidden=true;toggle.setAttribute('aria-expanded','false');document.body.classList.remove('menu-open');}});
  }
  document.querySelectorAll('.nav-dropdown').forEach(item=>{
    item.addEventListener('toggle',()=>{if(item.open)document.querySelectorAll('.desktop-navigation .nav-dropdown').forEach(other=>{if(other!==item)other.open=false;});});
  });
  document.addEventListener('click',ev=>{
    document.querySelectorAll('.desktop-navigation .nav-dropdown[open]').forEach(item=>{if(!item.contains(ev.target))item.open=false;});
  });
  document.querySelectorAll('[data-filter-toggle]').forEach(btn=>{
    btn.addEventListener('click',()=>{
      const sidebar=document.getElementById(btn.getAttribute('aria-controls'));
      if(!sidebar)return;
      const show=!sidebar.classList.contains('is-open');
      sidebar.classList.toggle('is-open',show);
      btn.setAttribute('aria-expanded',String(show));
    });
  });
  document.querySelectorAll('[data-filter-close]').forEach(btn=>btn.addEventListener('click',()=>{
    const sidebar=btn.closest('.catalog-sidebar');if(sidebar)sidebar.classList.remove('is-open');
    document.querySelectorAll('[data-filter-toggle]').forEach(b=>b.setAttribute('aria-expanded','false'));
  }));
  document.querySelectorAll('[data-sort-select]').forEach(select=>{
    select.addEventListener('change',()=>{
      const url=new URL(window.location.href);
      url.searchParams.set('sort_by',select.value);
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    });
  });
  document.querySelectorAll('[data-product-thumb]').forEach(button=>{
    button.addEventListener('click',()=>{
      const image=document.getElementById(button.dataset.productThumb);
      if(image){image.src=button.dataset.imageSrc;image.alt=button.dataset.imageAlt||image.alt;}
      button.parentElement.querySelectorAll('button').forEach(b=>b.classList.toggle('selected',b===button));
    });
  });
  document.querySelectorAll('[data-product-variant]').forEach(select=>{
    select.addEventListener('change',()=>{
      const option=select.selectedOptions[0], id=select.dataset.sectionId;
      const formatter=new Intl.NumberFormat(document.documentElement.lang||'pl-PL',{style:'currency',currency:select.dataset.currency||'PLN'});
      const price=document.querySelector('[data-variant-price]');
      const compare=document.querySelector('[data-variant-compare]');
      const stock=document.querySelector('[data-variant-stock]');
      const buy=document.querySelector('[data-buy-button]');
      const buyText=document.querySelector('[data-buy-button-text]');
      const amount=Number(option.dataset.price||0),old=Number(option.dataset.compare||0),available=option.dataset.available==='true';
      if(price)price.textContent=formatter.format(amount/100);
      if(compare){compare.hidden=!(old>amount);if(old>amount)compare.textContent=formatter.format(old/100);}
      if(stock){stock.classList.toggle('stock--yes',available);stock.innerHTML='<i></i>'+ (available?'Produkt dostępny':'Produkt niedostępny');}
      if(buy)buy.disabled=!available;
      if(buyText)buyText.textContent=available?'Dodaj do koszyka':'Niedostępny';
      if(option.dataset.image){const img=document.getElementById('product-main-image-'+id);if(img)img.src=option.dataset.image;}
      const next=new URL(window.location.href);next.searchParams.set('variant',option.value);window.history.replaceState(null,'',next.toString());
    });
  });
})();
